// $(function(){
//   objectFitImages('.js-objectfit-img');
// });

$(window).on("load", function () {
  $('.js-recruit-slider').slick({
    slidesToShow: 5,
    padding: 10,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 0, //待ち時間を０に
    speed: 7000, // スピードをゆっくり
    swipe: false, // 操作による切り替えはさせない
    cssEase: 'linear', // 切り替えイージングを'linear'に
    // 以下、操作後に止まってしまう仕様の対策
    pauseOnFocus: false,
    pauseOnHover: false,
    pauseOnDotsHover: false,
    responsive: [{
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
      }
    }]
  });
});

$('.js-recruit-slider').on('init', function(event, slick, direction) {
  $('.p-recruit__slide').css('opacity', '1');
});

$('.p-recruit02__btn_president01').click(function () {
  $(this).prev().slideToggle();
  $(this).toggleClass('open');
});

// tab
$(function() {
  $('.p-recruit02__tagList li').click(function() {
    var index = $('.p-recruit02__tagList li').index(this);
    tabBoxClick(index);
  });
});

function tabBoxClick(index) {
  var tabindex = index + 1;
  $('.p-recruit__box').fadeOut();
  $('.tabBox0' + tabindex).fadeIn();
  $('.p-recruit02__tagList li').removeClass('active');
  $('.p-recruit02__tagList li').eq(index).addClass('active');

  return false;
}
